import script from "./AbstractHeaderFooterDetailContent.vue?vue&type=script&lang=ts"
export * from "./AbstractHeaderFooterDetailContent.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__